import React, { useEffect } from 'react';
import useExpand from '../../../../../hooks/use-expand';
import { FilterStatusesGroupProps } from './filter-statuses-group.types';
import { StyledFilterStatusesGroupContainer } from './filter-statuses-group.styled';
import ThreeStateCheckbox from '../../../../three-state-checkbox';
import { FilterStatusesCheckboxStateTypes } from '../filter-statuses.types';
import { Direction, Divider, Flex, Rotate, Text } from '../../../../../common/common-components.styled';
import { ArrowDownIcon } from '../../../../icons-new/arrow-down';
import EllipsisWithTooltip from '../../../../ellipsis-with-tooltip';
import useEventDescriptionsUtils from '../../../../../hooks/use-event-descriptions-utils';

const FilterStatusesGroup = ({
  group,
  groupCheckboxState,
  updateCheckboxState,
  isLastOneGroup,
  inputValue
}: FilterStatusesGroupProps) => {
  const { height, content, toggleAccordion, expand } = useExpand(false, true);
  const { getAppStatusTextById } = useEventDescriptionsUtils();

  useEffect(() => {
    if (inputValue && !expand) {
      setTimeout(() => toggleAccordion(), 50);
    }
  }, [inputValue]);

  return (
    <div>
      <StyledFilterStatusesGroupContainer
        onClick={toggleAccordion}
        active={expand || groupCheckboxState.checked}
        justify='space-between'
      >
        <Flex align='center'>
          <ThreeStateCheckbox
            indeterminate={groupCheckboxState.indeterminate}
            checked={groupCheckboxState.checked}
            onChange={e => updateCheckboxState(FilterStatusesCheckboxStateTypes.Group, !e.checked, group.title)}
          />
          <Text left='10' color='grey600' bold>
            {group.title}
          </Text>
        </Flex>

        <Rotate rotateDirection={expand ? Direction.Top : Direction.Bottom}>
          <ArrowDownIcon width={15} height={12} strokeWidth={2} />
        </Rotate>
      </StyledFilterStatusesGroupContainer>

      <div ref={content} style={{ height: height, overflow: 'hidden', transition: 'all .2s' }}>
        {group.items.map(item => {
          const checked =
            groupCheckboxState.items.find(
              groupCheckboxStateItem => groupCheckboxStateItem.id === item.uds_fahrzeugbestellungeneventdescriptionid
            )?.checked || false;
          const { appStatusText } = getAppStatusTextById(item.uds_fahrzeugbestellungeneventdescriptionid) || '-';

          return (
            <StyledFilterStatusesGroupContainer
              onClick={() =>
                updateCheckboxState(
                  FilterStatusesCheckboxStateTypes.Item,
                  !checked,
                  item.uds_fahrzeugbestellungeneventdescriptionid
                )
              }
              key={item.uds_fahrzeugbestellungeneventdescriptionid}
              active={checked}
            >
              <ThreeStateCheckbox
                indeterminate={false}
                checked={checked}
                onChange={e =>
                  updateCheckboxState(
                    FilterStatusesCheckboxStateTypes.Item,
                    !e.checked,
                    item.uds_fahrzeugbestellungeneventdescriptionid
                  )
                }
              />
              <EllipsisWithTooltip tooltip={appStatusText} maxWidth='300px'>
                <Text left='10' color='grey600'>
                  {appStatusText}
                </Text>
              </EllipsisWithTooltip>
            </StyledFilterStatusesGroupContainer>
          );
        })}
        {!isLastOneGroup && <Divider bottom='5' />}
      </div>
    </div>
  );
};

export default FilterStatusesGroup;
